import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getTabResource } from 'Views/Onboarding/utils';
import { useBalanceSheetContext } from '../../BalanceSheetContext';
import BalanceSheetLineItemSection from './BalanceSheetLineItemSection';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  section: {},
});

const BalanceSheetTabContent = ({
  className,
  classes,
  balanceSheetStepResource,
}) => {
  const { tabName } = useBalanceSheetContext();
  const tabResource = getTabResource(balanceSheetStepResource, tabName);

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {tabResource.attr('sections').resources().list().map((sectionResource) => {
        return (
          <BalanceSheetLineItemSection
            key={sectionResource.id()}
            className={classes.section}
            sectionResource={sectionResource}
          />
        );
      })}
    </Box>
  );
};

BalanceSheetTabContent.defaultProps = {
  className: '',
};

BalanceSheetTabContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  balanceSheetStepResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(BalanceSheetTabContent);
